import React from "react";
import AssistantChat from "../../../components/AssistantChat";

// Minimal replacement: render AssistantChat where the floating summary button used to be.
// Accept previous props but ignore them for now; keep signature to avoid breaking callers.
const FloatingSummaryButton = ({ goldenId, ...rest }) => {
  return <AssistantChat />;
};

export default FloatingSummaryButton;
